import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7b993326"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "namespace-icon-view" }

import { TirPmSvg } from "tir-components";


export default /*#__PURE__*/_defineComponent({
  __name: 'namespace-icon-view',
  props: {
  /**Цвет иконки */
  color: {
    type: String,
    required: true,
  },
  /**Иконка */
  icon: {
    type: String,
    required: true,
  },
  /**Размер иконки */
  size: {
    type: Number,
    default: 24,
  },
  /**Паддинг иконки */
  padding: {
    type: Number,
    default: 3,
  },
},
  setup(__props) {

const props = __props;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(TirPmSvg), {
      class: "namespace-icon-view__icon",
      url: __props.icon,
      style: _normalizeStyle({
        fontSize: `${__props.size / 16}rem`,
      }),
      color: __props.color
    }, null, 8, ["url", "style", "color"])
  ]))
}
}

})